export default __webpack_public_path__ + "static/media/loan_white.ec4cb854.svg";